require('./creditCancelView.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
// @ utilities
const { FormattedText, formatText, getLanguage, getFinalTitle } = require('core/i18n').i18n;
const DateHelper = require('utilities/dateHelper');
const { getLastNChars } = require('utilities/stringHelper');
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
// @ actions
const { cancelPregrantedCredit, clear } = require('actions/credits/cancelPregrantedCredit');
// @ commons
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList.js');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem.js');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const { OKMessage } = require('commonsComponents/OKMessage');
// @ components
const { LoadingSection } = require('commonsComponents/loadingSection');
const SignaturePatternButton = require('components/signaturePattern/signaturePatternButton/signaturePatternButton');
const SignaturePattern = require('components/signaturePattern/signaturePattern').SignaturePattern;
const CreditCancelError = require('components/credits/creditCancelError/creditCancelError');
const CreditCancelSuccess = require('components/credits/creditCancelSuccess/creditCancelSuccess');
const TutorialLauncher = require('components/tutorial/tutorialLauncher');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')
// @ constants
const { CREDIT_PREGRANTED_CANCEL } = require('constants/operationTypes');
const { API_ENTERPRISE_NUMBER, API_CENTER, GRAPHIC_TUTOR_TYPE_4 } = require('constants/index');

//@contactCenter
const { ConfirmationScript, CONFIRMATION_SCRIPT_GREETING, CONFIRMATION_SCRIPT_AGREEMENT } = require('components/contactCenter/confirmScript/confirmationScript');


class CreditCancelView extends React.Component {
    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleGotoPregrantedCreditView = this.handleGotoPregrantedCreditView.bind(this);
    }

    componentDidMount() {
        const { match: { params: { creditId } }, immCredits } = this.props;
        const immCredit = immCredits.getIn(['byId', creditId]);

        if (!immCredit.has('details')) {
            this.handleGotoPregrantedCreditView();
        }
    }

    componentWillUnmount() {
        this.props.clear();
    }

    buildError() {
        return <CreditCancelError />;
    }

    buildMainView(immCredit) {
        const { immCreditCancelPregranted, immAccounts } = this.props;
        const immAccount = immAccounts.getIn(['byId', immCredit.get('accountId')]);
        const startingDate = DateHelper.formatDate(immCredit.getIn(['details', 'startingDate']))
        const operationParams = {
            originAccount: API_ENTERPRISE_NUMBER + API_CENTER + immCredit.get('product') + immCredit.get('contractNumber')
        };
        const accountBalance = immAccount.getIn(['balances', 'realBalance']);
        const showWarningMessage = accountBalance.get('amount') < 0;
        const iban = immCredit.get('iban');
        const formattedIban = getLastNChars(iban, 4, '*', 4);
        const formattedAccount = `${immAccount.get('alias')} ${formattedIban}`;
        const plainAmountBalanceObject = getPlainAmountObject(accountBalance);
        const plainAmountLimitObject = getPlainAmountObject(immCredit.get('limit'));
        const language = getLanguage();
        let warningMessage;

        if (showWarningMessage) {
            warningMessage = (
                <OKMessage type="important">
                    <FormattedText value="creditCancel-warningMessage" />
                </OKMessage>
            );
        }

        return (
            <OKSectionBox className="credit-cancel-view--stretch">
                <article id="printable-wizard" className="credit-cancel-view__main-content">
                    <header className="credit-cancel-view__title">
                        <FormattedText value="creditCancel-subtitle" />
                    </header>
                    <ContactCenterRender>
                        <ConfirmationScript
                            operative={formatText('operatives-loansAndMortgage_cancelCredit')}
                            confirmationType={CONFIRMATION_SCRIPT_GREETING}
                        />
                    </ContactCenterRender>
                    <section className="credit-cancel-view__data-section">
                        <section className="credit-cancel-view__caveat-message">
                            <FormattedText value="creditCancel-caveatMessage" />
                        </section>
                        <OKInformativeList columns={2}>
                            <OKInformativeListItem title="creditCancel-accountNumber" bodyText={formattedAccount} />
                            <OKInformativeListItem title="creditCancel-capital">
                                <OneLineSymbolAmount
                                    className="credit-cancel-view__amount"
                                    amountObject={plainAmountBalanceObject}
                                    language={language}
                                    amountObjectFormatted={formatAmountObject(plainAmountBalanceObject, true)} />
                            </OKInformativeListItem>
                            <OKInformativeListItem title="creditCancel-contractDate" bodyText={startingDate} />
                            <OKInformativeListItem title="creditCancel-limit" >
                                <OneLineSymbolAmount
                                    className="credit-cancel-view__amount"
                                    amountObject={plainAmountLimitObject}
                                    language={language}
                                    amountObjectFormatted={formatAmountObject(plainAmountLimitObject, true)} />
                            </OKInformativeListItem>
                            <OKInformativeListItem title="creditCancel-holder" bodyText={immCredit.get('holder')} />
                        </OKInformativeList>
                        <ContactCenterRender>
                            <ConfirmationScript confirmationType={CONFIRMATION_SCRIPT_AGREEMENT} />
                        </ContactCenterRender>
                        {warningMessage}
                    </section>
                    <section className="credit-cancel-view__signature-pattern">
                        <SignaturePattern
                            operationType={CREDIT_PREGRANTED_CANCEL}
                            operationParams={operationParams}
                        />
                    </section>
                    <footer className="credit-cancel-view__footer">
                        <div className="pull-left">
                            <OKButton modifier="link-ghost" onClick={this.handleGotoPregrantedCreditView}>
                                <FormattedText value="common-cancel" />
                            </OKButton>
                        </div>
                        <SignaturePatternButton
                            onClick={this.handleSubmit}
                            loading={immCreditCancelPregranted.get('isFetching')}
                        >
                            <FormattedText value="common-confirm" />
                        </SignaturePatternButton>
                    </footer>
                </article>
            </OKSectionBox>
        );
    }

    buildSuccess(immCredit) {
        return <CreditCancelSuccess immCredit={immCredit} />;
    }

    handleGotoPregrantedCreditView() {
        this.props.history.push(`/myprofile/loans-mortgages/credit/pregranted-credit/${this.props.match.params.creditId}`);
    }

    handleSubmit() {
        const { match: { params: { creditId } }, cancelPregrantedCredit } = this.props;

        if (creditId) {
            cancelPregrantedCredit(creditId);
        }
    }

    render() {
        const { match: { params: { creditId } }, immCredits, immCreditCancelPregranted } = this.props;

        const immCredit = immCredits.getIn(['byId', creditId]);
        let sectionContent;

        if (immCredit) {
            const mappingBreadcrumb = [
                {
                    text: formatText('breadcrumb-loansAndMortgages'),
                    url: '/myprofile/loans-mortgages'
                },
                {
                    text: formatText('breadcrumb-pregrantedCredit', [getLastNChars(immCredit.get('iban'), 4, '.', 4)]),
                    url: `/myprofile/loans-mortgages/credit/pregranted-credit/${creditId}`
                },
                {
                    text: formatText('breadcrumb-creditCancel')
                }
            ];
            const tutorial = (
                <TutorialLauncher
                    type={GRAPHIC_TUTOR_TYPE_4}
                    title={formatText('tutorials-loansCancelCreditTitle')}
                />
            );

            if (immCreditCancelPregranted.get('success')) {
                sectionContent = this.buildSuccess(immCredit);
            } else if (immCreditCancelPregranted.get('error')) {
                sectionContent = this.buildError();
            } else {
                sectionContent = this.buildMainView(immCredit);
            }

            return (
                <section className="credit-cancel-view">
                    <OKCover size="medium" section="loansmortgages">
                        <OKHeaderSubPage
                            breadcrumbConfig={mappingBreadcrumb}
                            tutorial={tutorial}
                            finalTitle={getFinalTitle('creditCancel-title')}
                        />
                    </OKCover>
                    <div className="credit-cancel-view__body">
                        {sectionContent}
                    </div>
                </section>
            );
        }

        return <LoadingSection />;
    }
}

CreditCancelView.propTypes = {
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immCredits: PropTypes.object.isRequired,
    immCreditCancelPregranted: PropTypes.object.isRequired,
    cancelPregrantedCredit: PropTypes.func.isRequired,
    clear: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    routes: PropTypes.array
};

module.exports.constructor = CreditCancelView;
module.exports.CreditCancelView = connect(
    state => ({
        immAccounts: state.accounts,
        immCredits: state.creditsPregranted,
        immCreditCancelPregranted: state.creditsCancelPregranted
    }), {
    cancelPregrantedCredit,
    clear
})(withRouter(CreditCancelView));
